var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAttachment = function SvgIcAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.592 11.705a3.521 3.521 0 0 0 4.049 1.19 3.52 3.52 0 0 0 1.259-.81l2.112-2.114A3.525 3.525 0 0 0 14.51 4a3.518 3.518 0 0 0-2.476.989l-1.211 1.205m1.584 4.101a3.52 3.52 0 0 0-4.049-1.19 3.52 3.52 0 0 0-1.259.81l-2.112 2.114a3.525 3.525 0 0 0 2.501 5.97 3.518 3.518 0 0 0 2.476-.988l1.204-1.205"
  })));
};
export default SvgIcAttachment;